var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"ui-tag-line",style:([_vm.textSizeCss, _vm.colorCss, _vm.radiusCss, _vm.backgroundCss])},[(_vm.title)?_c('strong',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }